import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Subscription } from 'rxjs';

import { ActivateComponentService } from './activate-component.service';
import { UserdataService } from './userdata.service';
import { ApiGatewayHelperService } from 'modules/app/services/apigateway-helper.service';
import { NetwordDetectionService } from 'modules/app/services/network-detection.service';
import config from './config';
import { DesktopNotesDataService } from './desktop-notes-data.service';
import { DesktopDrawingsDataService } from './desktop-drawings-data.service';
import { DesktopUserPreferencesService } from './desktop-user-preferences-data.service';
import { environment } from 'environments/environment';

@Injectable()
export class HelperService {

    isOnline: boolean = false;
    networkStatusSubscription: Subscription;
    userSpecificBookData:any = {
        'notes' : {
            'allNotes': [],
            'errorResponse' : {}
        },
        'drawings' : {
            'allDrawings': [],
            'errorResponse': {}
        },
        'preferences' : {
            'lastAccessedPage' : {},
            'errorResponse' : {}

        },
        'allDataReceived': false
    };

    // array to hold image paths which were downloaded sucecssfully
    downloadedUmbrellaImages: any;
    // array to hold image paths which could not be downloaded or have been delted in this app launch
    nonDownloadedUmbrellaImages: any;
    // array to hold image paths whose status check request has been sent to BE
    // relevant in offline mode only
    umbrellaImagesDnldStatusReqInProcess: any;

    
    constructor(
        private activateComponentService: ActivateComponentService,
        private userdataService: UserdataService,
        private desktopNotesDataService: DesktopNotesDataService,
        private desktopDrawingsDataService: DesktopDrawingsDataService,
        private desktopUserPreferencesService: DesktopUserPreferencesService,
        private http: HttpClient,
        private apiGatewayHelperService: ApiGatewayHelperService,
        private networkService: NetwordDetectionService,
    ) {

        // running the constructor's code only in desktop mode
        // running the code in web app was creating error as 
        // definition of BroadcastChannel was not present in window's scope
        // and in strict mode it stops the app to load in iOS devices
        if(environment.isDesktopApp){
            this.downloadedUmbrellaImages = [];
            this.nonDownloadedUmbrellaImages = [];
            // relevant in offline mode only
            this.umbrellaImagesDnldStatusReqInProcess = [];
    
            // Event listener to check whether an image has been downloaded
            DLS_IPCListeners.SET_FILE_DOWNLOAD_STATUS = async (data) => {
                this.setBundleImageDownloadStatus(data);
            };
    
            try {
                (async () => {
                    this.isOnline = await this.networkService.isOnline(true);
                })();
            } catch (err) {
                this.isOnline = false;
            }
            this.networkStatusSubscription = this.networkService.monitorStatus().subscribe(async (isOnline) => {
                this.isOnline = isOnline;
            });
            
            this.isBundleImagePresent = this.isBundleImagePresent.bind(this);
        }
    }

    /**
     * To get PE code from bundle 
     * Required to create cover image path
     */
    public getOlpPeCode(bundle) {
        let code;
        bundle.products.forEach(element => {
            if (element['ext-product'].type == "OLP" && element['dls-product'].type == "courseware") {
                code = element['dls-product'].code;
            }
        });
        return code;
    }

    public isAbsoluteUrl(url) {
        var pat = /(^https?:\/\/)|(^\/\/)/i;
        return pat.test(url)
    }

    /* public getImageURL(bundle){
        let peCode = this.getOlpPeCode(bundle);
        return (this.isAbsoluteUrl(bundle.image) ? bundle.image : (bundle.image != undefined && peCode != undefined ? bundle.path + '/' + peCode + '/' + bundle.image : undefined));
    } */

    public getImageURL(bundle) {
        bundle.cover = "";
        if (this.isAbsoluteUrl(bundle.image)) {
            return bundle.image;
        } else if (bundle.attribs && bundle.attribs.hasOwnProperty('cover-product-code')) {
            bundle.cover = bundle.path + '/' + bundle.attribs['cover-product-code'] + '/' + bundle.image;
        } else {
            let olpProduct;
            olpProduct = bundle.products.find((product) => product['ext-product'].type === 'OLP');
            if (!olpProduct || (olpProduct && olpProduct.meta['not-published'])) {
                delete bundle.cover;
            } else {
                if (bundle.image) {
                    bundle.cover = bundle.path + '/' + bundle.products.find((product) => product['ext-product'].type === 'OLP')['dls-product'].code + '/' + bundle.image;
                } else {
                    delete bundle.cover;
                }
            }
        }
        bundle.image = bundle.cover;
        return bundle.image;
    }

    public isProductActive(product){
        let user = this.userdataService.getLoggedInUser();
        let productCode = ((product['dls-product'] && product['dls-product'].code) || product.productcode);
        let isActivated = ((this.activateComponentService.getEntitlementsForUser() || []).indexOf(productCode) >= 0)
        if(this.isProductExpired(product)) {
            product.isExpired = true;
        }
        return (product.activation.free[user.role] || isActivated || (product && product.activation && product.activation['prior-to-activitation-rules']=="disabled"));
    }

    public isProductExpired(product) {

        let productCode = ((product['dls-product'] && product['dls-product'].code) || product.productcode);
        let entitlementExpiryMap = this.getEntitlementToExpireDateForUser();
        let isExpired = ((this.activateComponentService.getExpiredEntitlementsForUser() || []).indexOf(productCode) >= 0);
        let expiryDateTimestamp = entitlementExpiryMap[productCode];
        let formatedDate;
        let timestampDifference;
        let thirtyDayWarning = false;
        
        if (window['disableExpiry'] && window['disableExpiry'] == 'expire') {
            expiryDateTimestamp = undefined;
            isExpired = false;
        }

        if (expiryDateTimestamp) {
            formatedDate = this.formatDate(expiryDateTimestamp);
            timestampDifference = expiryDateTimestamp - Date.now();
            if (timestampDifference <= 30 * (1000 * 3600 * 24)) {
                thirtyDayWarning = true;
            }
        }

        product.expiryConfig = {
            expiryDateTimestamp: expiryDateTimestamp,
            formatedDate: formatedDate,
            thirtyDayWarning: thirtyDayWarning,
            isExpired: isExpired
        }

        return isExpired;

    }

    public isEbookVisible(product, spaceId, checkForComingSoon = true) {

        product = JSON.parse(JSON.stringify(product));
        // show product if not ebook
        if (product['ext-product'].type != 'imgbook') {
            return true;
        }

        let isMQA = false;

        if(Array.isArray(spaceId)) {
            spaceId.forEach(space => {
                if(space.indexOf("mqa") === 4) {
                    isMQA = true;
                }
            })
        } else {
            isMQA = spaceId.indexOf("mqa") === 4;
        }

        if (isMQA) return true;
        if (product.meta == undefined) return true;
        if (product.meta.visibility == undefined) return true;
        if (product.meta.visibility == 'true') return true;
        if (checkForComingSoon && product.meta.visibility == 'coming-soon') return true;
        return false;

    }

    public isEbookOrPPlus(product) {
        if (product['ext-product'].type == 'imgbook' || product['ext-product'].type == 'imgbook-pplus') {
            return true;
        }
        return false;
    }

    public isEbookHandledAsComingSoon(product, spaceId) {

        product = JSON.parse(JSON.stringify(product));
        // show product if not ebook
        if (product['ext-product'].type != 'imgbook') {
            return false;
        }

        let isMQA = false;

        if(Array.isArray(spaceId)) {
            spaceId.forEach(space => {
                if(space.indexOf("mqa") === 4) {
                    isMQA = true;
                }
            })
        } else {
            isMQA = spaceId.indexOf("mqa") === 4;
        }

        if (isMQA) return false;
        if (product.meta == undefined) return false;
        if (product.meta.visibility == undefined) return false;
        if (product.meta.visibility == 'coming-soon') return true;
        return false;

    }

    public getManifests(options) {
        return new Promise((res,rej)=> {
            if(this.isOnline){
                this.http.post(config.app.api.baseUrl + this.apiGatewayHelperService.getApiGatewayPrefixUrl()  + "manifests", {options }).toPromise()
                .then((data)=> {
                    res(data);
                }).catch((err)=> {
                    console.log("Error while fetching manifests", err);
                    rej(err);
                });
            }else{
                rej("SYSTEM_OFFLINE");
            }
        });
        
    }

    /** 
     * fetch user specific data (notes/drawings/prefernces) and save the data in RxDb
     * @params - productCode (type - string) 
     *  - options (type - object)  = {"bundleCode": bundleCode, "spaceId": spaceId, "uid": this.userData.uid}
    */
    public getUserSpecificBookData(productCode, options) {
        var promises = []
        if(this.isOnline) {
            options.productCode = productCode;
            promises.push(this.fetchNotes(options));
            promises.push(this.fetchDrawings(options));
            promises.push(this.fetchPreferences(options));

        }
        Promise.all(promises)
            .then(async (responses) => {
                this.userSpecificBookData.allDataReceived = true;
                // save data in db
                if (responses[0] && responses[0].length) {
                    this.desktopNotesDataService.setBulkNotes({ "uid": options.uid, "ebookCode": productCode, "data": responses[0] });
                }
                // save data in db
                if (responses[1] && responses[1].length) {
                    this.desktopDrawingsDataService.setBulkDrawings({ "uid": options.uid, "ebookCode": productCode, "data": responses[1] });
                }
                // save data in db
                if (responses[2] && responses[2].length) {
                    this.desktopUserPreferencesService.setBulkUserPreferences({ "uid": options.uid, "ebookCode": productCode, "data": responses[2] });
                }
            })
            .catch(err => {
                console.log("err in fetching user data: ", err);
            })
    }

    public fetchNotes(options) {
        this.userSpecificBookData.notes.allNotes = [];
        return new Promise (async (res, rej)=> {
            try{
                if(this.isOnline){
                    let notesdata:any = await this.http.post(config.app.api.baseUrl + this.apiGatewayHelperService.getApiGatewayPrefixUrl()  + 'fetchNotes' , {'cursor':options.cursor, 'studentBookCode': options.productCode}).toPromise();
                    if(notesdata.status && notesdata.status == "error"){
                        console.log("Remote Call Error:");
                        this.userSpecificBookData.notes.errorResponse = {"status":"error", "type" : "NOTES_DATA_API_ERROR"};
                        this.userSpecificBookData.notes.allNotes = [];
                        res(this.userSpecificBookData.notes.errorResponse);
                        return; 
                        
                    }
                    this.userSpecificBookData.notes.allNotes = this.userSpecificBookData.notes.allNotes || [];
                    notesdata.entities.forEach((note)=> {
                        let obj = {
                            "documentId": "cup"+note.documentid,
                            "folderId": note.folderid,
                            "data": note.data,
                            "timestamp": note.user_modified,
                            "meta": {
                                created: note.created
                            }
                        };
                        this.userSpecificBookData.notes.allNotes.push(obj);
                    });
        
                    res(this.userSpecificBookData.notes.allNotes);
                        
                }else{
                    rej("SYSTEM_OFFLINE");
                }
            } catch(error) {
                
                console.log("Error occured while fetching notes");
                console.log(error);
                this.userSpecificBookData.notes.errorResponse = {"status":"error", "type" : "EXCEPTION_THROWN"};
                this.userSpecificBookData.notes.allNotes = [];
                rej(this.userSpecificBookData.notes.errorResponse); 
            }
        });
    }

    public fetchDrawings(options) {
        this.userSpecificBookData.drawings.allDrawings = [];
        return new Promise((res,rej)=> {
            if(this.isOnline){
                this.http.post(config.app.api.baseUrl + this.apiGatewayHelperService.getApiGatewayPrefixUrl() + "fetchAnnotations", { "bookCode": options.productCode }).toPromise()
                    .then((data: any) => {
                        if (data && data[0] && data[0].entities && data[0].entities.length) {
                            data[0].entities.forEach((drawing) => {
                                let obj = {
                                    "documentId": "cup" + drawing.documentid,
                                    "folderId": drawing.folderid,
                                    "data": drawing.data,
                                    "timestamp": drawing.user_modified
                                };
                                this.userSpecificBookData.drawings.allDrawings.push(obj);
                            });
                        }
                        res(this.userSpecificBookData.drawings.allDrawings);
                    }).catch((err) => {
                        console.log("Error while fetching drawings", err);
                        rej(err);
                    });
                    
            }else{
                rej("SYSTEM_OFFLINE");
            }
        });
    }

    public fetchPreferences(options) {
        this.userSpecificBookData.preferences.lastAccessedPage = [];
        return new Promise((res,rej)=> {
            if(this.isOnline){
                this.http.get(config.app.api.baseUrl + this.apiGatewayHelperService.getApiGatewayPrefixUrl()  + "preferences/" + options.productCode).toPromise()
                    .then((response: any) => {

                        if (response && response.data && response.data.entities && response.data.entities.length) {
                            response.data.entities.forEach((preference) => {
                                let obj = {
                                    "documentId": "cup" + preference.documentid,
                                    "folderId": preference.folderid,
                                    "data": preference.data,
                                    "timestamp": preference.user_modified
                                };
                                this.userSpecificBookData.preferences.lastAccessedPage.push(obj);
                            });
                        }
                        res(this.userSpecificBookData.preferences.lastAccessedPage);
                    }).catch((err) => {
                        console.log("Error while fetching preferences", err);
                        rej(err);
                    });
            }else{
                rej("SYSTEM_OFFLINE");
            }
        });
    }

    public delUserSpecificBookData(productCode, options) {
        return new Promise((res,rej)=> {
            var promises = [];
            promises.push(this.desktopNotesDataService.deleteNotes({"uid": options.uid, "ebookCode" : productCode}));
            promises.push(this.desktopDrawingsDataService.deleteDrawings({"uid": options.uid, "ebookCode" : productCode}));
            promises.push(this.desktopUserPreferencesService.deleteUserPreferences({"uid": options.uid, "ebookCode" : productCode}));
    
            Promise.all(promises).then(async (response)=> {
                console.log(response);
              res({status:"success", data:response});  
            }).catch((err)=> {
                rej({status:"error", data:err});
            });

        });

    }
    
    //reset required note data service variables when book is toggled  
    // resetAllNotes() {
        // this.allNotes = undefined;
        // this.orphanNotes = [];
        // this.pages = [];
        // this.isRemoteCall = true;
        // this.errorResponse = {};
    // }




    public fetchBundleImage(bundle){
        let orgURL = this.getImageURL(bundle),
            destPath;
        if(orgURL){
            let imgName = "cover."+orgURL.split(".").pop();
            destPath = `${window['appUmbImagesDownloadsLoc']}/${bundle['bundle-code']}/${imgName}`;
            orgURL = destPath;
        }
        return orgURL;
    }

    /**
     * method to check whether a bundle has a cover image defined for it
     * and whether that image has been downloaded in user's machine
     * @param bundle : bundle for which the check has to be performed
     */
    public isBundleImagePresent(bundle){
        if(this.isOnline) {
            // if user is online, return the path to access the image online
            return bundle.imgError ? false : (this.getImageURL(bundle) || false);

        } else {

            if(!bundle.imageURL){
                return false;
            }else if(this.nonDownloadedUmbrellaImages.indexOf(bundle.imageURL) >= 0){
                // check if image was not downloaded or was removed
                // and thus is not present in user's machine
                return false;
            }else if(this.downloadedUmbrellaImages.indexOf(bundle.imageURL) >= 0){
                // check if image is present in user's machine
                return bundle.imageURL;
            }

            // when the app islaunched in offline mode, none of above scenario will be satisfied, then
            // ask desktop app backend to confirm the status of bundle image in user's machine
            // the confirmation data will not be used in this iteration itself. 
            // But it will be used when browser requests for this image next time 
            // after the response has come

            // check if image status request is not in progress
            if(this.umbrellaImagesDnldStatusReqInProcess.indexOf(bundle.imageURL) == -1){
                this.umbrellaImagesDnldStatusReqInProcess.push(bundle.imageURL);
                // request backend for file download status
                DLS_IPCCallers
                    .GET_FILE_DOWNLOAD_STATUS(bundle.imageURL)
                    .then(res => {
                        this.setBundleImageDownloadStatus({filePath: bundle.imageURL, status: res});
                    })
                    .catch(err => {
                        this.setBundleImageDownloadStatus({filePath: bundle.imageURL, status: false});
                    })
            }
    
            return false;
        }

    }

    setBundleImageDownloadStatus({filePath, status}){
        if(this.umbrellaImagesDnldStatusReqInProcess.indexOf(filePath) >= 0){
            this.umbrellaImagesDnldStatusReqInProcess.splice(this.umbrellaImagesDnldStatusReqInProcess.indexOf(filePath), 1);
        }
        if(!!status){
            // add to nonDownlaoded Images array if not present already
            if(this.downloadedUmbrellaImages.indexOf(filePath) == -1){
                this.downloadedUmbrellaImages.push(filePath);
            }
            // remove if filepath is present in downloadedImagesArr
            if(this.nonDownloadedUmbrellaImages.indexOf(filePath) >= 0){
                this.nonDownloadedUmbrellaImages.splice(this.nonDownloadedUmbrellaImages.indexOf(filePath), 1);
            }
        }else{
            // add to nonDownlaoded Images array if not present already
            if(this.nonDownloadedUmbrellaImages.indexOf(filePath) == -1){
                this.nonDownloadedUmbrellaImages.push(filePath);
            }
            // remove if filepath is present in downloadedImagesArr
            if(this.downloadedUmbrellaImages.indexOf(filePath) >= 0){
                this.downloadedUmbrellaImages.splice(this.downloadedUmbrellaImages.indexOf(filePath), 1);
            }
        }
    }

    getEntitlementToExpireDateForUser() {
        return this.activateComponentService.getEntitlementToExpireDateForUser();
    }

    formatDate(timestamp) {
        let expiryDate = new Date(timestamp);
        let formattedDateArray = expiryDate.toLocaleDateString('en-GB', {
            day: 'numeric', month: 'short', year: 'numeric'
        }).split(' ');
        return formattedDateArray[1] + ' ' + formattedDateArray[0] + ', ' + formattedDateArray[2];
    }

    initWalkthrough(translations, loggedInUser, onGuidedTourExit = undefined) {
        let steps = [
            {
                descHeading: translations.FOC.DESKTOP.GUIDED_TOUR.WELCOME_HEADING,
                desc: translations.FOC.DESKTOP.GUIDED_TOUR.WELCOME_DESC,
            },
            {
                element: document.getElementsByClassName("image-group d-flex flex-column")[0],
                descHeading: translations.FOC.DESKTOP.GUIDED_TOUR.DOWNLOAD_HEADING,
                desc: translations.FOC.DESKTOP.GUIDED_TOUR.DOWNLOAD_DESC,
            },
            {
                element: document.getElementsByClassName('badge')[0],
                descHeading: translations.FOC.DESKTOP.GUIDED_TOUR.ONLINE_HEADING,
                desc: translations.FOC.DESKTOP.GUIDED_TOUR.ONLINE_DESC,
            },
            {
                element: document.getElementsByClassName('helpbtn')[0],
                descHeading: translations.FOC.DESKTOP.GUIDED_TOUR.HELP_HEADING,
                desc: translations.FOC.DESKTOP.GUIDED_TOUR.HELP_DESC,
            }
        ]

        // this.walkthroughService.init([translations], steps, loggedInUser, [onGuidedTourExit]);
    }

}